import React from 'react';
import Warehouse from '../resorcesfiles/ideak/Warehouse.png'; // Replace with the appropriate image path
import Mainmastet from '../masterpage/Mainmastet';

const ProjectWarehouse = () => {
  return (
    <Mainmastet content={<>  
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
      <h1>RFID IN WAREHOUSE MANAGEMENT</h1>
      <p>
        The RFID warehouse management system (middleware) is a kind of system to process the RFID tags data from the RFID readers. It’s also a link to tie the RFID readers and warehouse management system together.
      </p>
      <h2>Architecture of the system:</h2>
      <p>
        The RFID tags are attached to the pallets, shelves, and location data. An RFID reader is mounted on a forklift equipped with a PLC to read the location and pallet tags. The display on the forklift can provide the operating directions for the moment.
      </p>
      <p>
        RFID readers and antennas are installed at different gate directions to judge pallet tags in and out. By using the wireless network in the warehouse, the system can realize data transmission.
      </p>
      <h2>Components of an RFID system</h2>
      <ul>
        <li>Passive RFID tags that are electronically programmed with unique information</li>
        <li>RFID label printer</li>
        <li>Mobile RFID reader</li>
        <li>Fixed Reader</li>
        <li>RFID Pallet Tags</li>
      </ul>
      <div style={{justifyContent:'center',alignItems:"center",display:'flex',flexDirection:'column'}}>
      <img src={Warehouse} alt="RFID Warehouse Management" style={{ maxWidth: '100%', height: 'auto' }} />
      </div>



      <div style={{height:'50px'}}></div>
    </div>

    
    
    </>} />
  );
};

export default ProjectWarehouse;
